import React from 'react';
import classNames from 'classnames';

import './RomaToolbarIcon.scss';

// TODO: This is placeholder component to mimic the currenbt toolbar icons background behaviour when using a Roma icon
// and should be removed in WEB-17078 once the toolbar has been migrated to the new design system

type RomaToolbarIconProps = {
       icon: React.ElementType<{ className?: string; 'aria-hidden'?: boolean }>;
       className?: string;
       iconClassName?: string;
   };

const RomaToolbarIcon = ({ icon: Icon, className, iconClassName }: RomaToolbarIconProps) => (
    <span className={classNames('RomaToolbarIcon', className)}>
        <span className="RomaToolbarIconBackground" />
        <Icon className={classNames("RomaToolbarIconGlyph", iconClassName)} aria-hidden />
    </span>
);

export default RomaToolbarIcon;
